module.exports = __webpack_public_path__ + "img/组 4.7d7b2fca.webp";